// The web app sends the refresh cookie set by api.akaiva-edu.com, so credentials are included (FR-033;
// the API allows exactly the app origins with credentials).
export const API_CREDENTIALS: RequestCredentials = "include";
